module.exports = __webpack_public_path__ + "img/img_converting_currency_phone.3533bd42.png";